import { render, staticRenderFns } from "./ClearanceCreatinina.vue?vue&type=template&id=33b85a0b"
import script from "./ClearanceCreatinina.vue?vue&type=script&lang=js"
export * from "./ClearanceCreatinina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports